export const OPTIONS = [
	// TODO: unhide when fan profile is ready to go
	// 'fanDatabase-optionsModal-view-profile',
	'fanDatabase-reset-password',
	'fanDatabase-optionsModal-refund-ticket',
	'fanDatabase-confirm-identity',
];

export const ICONS = ['user2', 'lock', 'dollar-sign', 'user-check'];
